import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/LevelSensor.css';
import levelImage from '../assets/level-sensor.png';
import ForkLevelSwitch from '../assets/Fork Level Switch.png';
import SubmersibleLevelTransmitterImg from '../assets/SubmersibleLevelTransmitterImg.png';
import SubmersibleLevelTransmitterPdf from '../assets/Fu-tek_Submersible Level Transmitter.pdf';
import radar27 from '../assets/27.png';
import radar28 from '../assets/28.png';
import pointLevel from '../assets/point-level.png';
import pointLevelSwitch from '../assets/pointLevelSwitch.png';
import capacitiveLevel from '../assets/capacitive-level.png';
import radarLevel from '../assets/radar-level.png';
import radarLevelMeter from '../assets/Radar_Level_Meter.png';
import { FaFilePdf, FaChevronRight, FaEnvelope } from 'react-icons/fa';

import LevelPdf from '../assets/Fu-tek_Level & Flow.pdf';
import ForkLevelSwitchPdf from '../assets/Fu-tek_Fork Level Switch.pdf';
import CapacitiveLevelTransmitterPdf from '../assets/Fu-Tek_Guide Radar Liquid Level Meter.pdf';
import RadarLevelTransmitterPdf from '../assets/Fu-tek_Intelligent Ultrasonic Level gauge.pdf';
import RadarLevel27Pdf from '../assets/Radar Level Transmitter.pdf';
import RadarLevelMeterPdf from '../assets/Fu-Tek_Radar Level Meter_FT-LE800K-20D.pdf';
import PointLevelSwitchPdf from '../assets/Point Level Switch.pdf';
// import QuoteModal from './QuoteModal';
import WhatsAppModal from './WhatsAppModal';

export default function LevelSensor() {
  const [activeTab, setActiveTab] = useState('levelswitch');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="LevelSensor-wrapper">
      <Header />

      <div className="hero-banner21">
        <div className="hero-banner21-content">
          <h1>LEVEL SENSORS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Level sensors</span>
          </div>
        </div>
      </div>

      <div className="level-content">
        <div className="level-row">
          <img src={levelImage} alt="Level Sensors" />
          <div className="level-description">
            <h2>Level sensors</h2>
            <ul>
              <li>High reliability due to the elimination of mechanical components</li>
              <li>Different function principles: Guided wave radar, capacitive and hydrostatic</li>
              <li>Devices for limit level detection or continuous level measurement</li>
              <li>Clearly visible LED display</li>
              <li>Suitable for all common industrial and process fluids</li>
            </ul>
            <div className="button-group">
              <a href={LevelPdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
              </a>
              <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
              {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            </div>
          </div>
        </div>

        <div className="level-tabs">
          <button className={activeTab === 'levelswitch' ? 'active' : ''} onClick={() => setActiveTab('levelswitch')}>Level Switch</button>
          <button className={activeTab === 'leveltransmitter' ? 'active' : ''} onClick={() => setActiveTab('leveltransmitter')}>Level Transmitter</button>
          <button className={activeTab === 'SubmersibleLevelTransmitter' ? 'active' : ''} onClick={() => setActiveTab('SubmersibleLevelTransmitter')}>Submersible Level Transmitter</button>
          
          
          {/* <button className={activeTab === 'forklevel' ? 'active' : ''} onClick={() => setActiveTab('forklevel')}>Fork Level Switch</button>
          <button className={activeTab === 'ultrasonic' ? 'active' : ''} onClick={() => setActiveTab('ultrasonic')}>Ultrasonic Level Gauge</button> */}
          {/* <button className={activeTab === 'radarmeter' ? 'active' : ''} onClick={() => setActiveTab('radarmeter')}>Radar Level Meter</button> */}

          {/* <button className={activeTab === 'technical' ? 'active' : ''} onClick={() => setActiveTab('technical')}>Technical Specifications</button> */}
        </div>

        <div className="tab-content">
          {activeTab === 'technical' && (
            <div className="responsive-table-wrapper">
              <table className="spec-table">
                <tbody>
                  <tr><td>Electrical design</td><td>PNP/NPN; (parameterisable)</td></tr>
                  <tr><td>Communication interface</td><td>IO-Link</td></tr>
                  <tr><td>Dimensions [mm]</td><td>250 x 28 x 16.7</td></tr>
                  <tr><td>Application</td><td>Continuous level measurement behind non-metallic and non-conductive surfaces</td></tr>
                  <tr><td>Media</td><td>dry bulk material; aqueous solutions; oils</td></tr>
                  <tr><td>Cannot be used for</td><td>highly adhesive media</td></tr>
                  <tr><td>Operating voltage [V]</td><td>10...30 DC; (IO-Link: 18...30 DC)</td></tr>
                  <tr><td>Current consumption [mA]</td><td>&lt; 50</td></tr>
                  <tr><td>Protection class</td><td>III</td></tr>
                  <tr><td>Reverse polarity protection</td><td>yes</td></tr>
                  <tr><td>Max. power-on delay time [ms]</td><td>1300</td></tr>
                  <tr><td>Measuring principle</td><td>capacitive</td></tr>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === 'SubmersibleLevelTransmitter' && (
            <div className="level-product-table">
<div className="level-product-left">
<div className="sensor-feature-card">
  <img src={SubmersibleLevelTransmitterImg} alt="Capacitance Level Switch" />
  <h3>Submersible Level Transmitter</h3>
<a href={SubmersibleLevelTransmitterPdf} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
</div>
                
              </div>
              <div className="sensor-right">
<table className="level-spec-table">
                  <tbody>
  <tr><td>Pressure range</td><td>0~1m…5m…10mH₂O</td></tr>
  <tr><td>Output Signal</td><td>4~20mA (24VDC)</td></tr>
  <tr><td>Operating Temperature</td><td>-20℃~85℃</td></tr>
  <tr><td>Zero temp. coefficient</td><td>±1.5%FS</td></tr>
  <tr><td>Span temp. coefficient</td><td>±1.5%FS</td></tr>
  <tr><td>Accuracy</td><td>±0.5%FS(Range&gt;1mH₂O);<br/> ±1%FS(Range≤1mH₂O)</td></tr>
  <tr><td>Protection</td><td>IP68</td></tr>
  <tr><td>Material</td><td>Stainless steel for level probe, Polyurethane wire for cable</td></tr>
  <tr><td>Medium compatibility</td><td>All kinds of media compatible with stainless steel 304</td></tr>
</tbody>

                </table>
              </div>
            </div>
          )}

{activeTab === 'levelswitch' && (
  <>
    {/* First Product */}
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={pointLevel} alt="Capacitance Level Switch" />
          <h3>Capacitance Level Switch</h3>
          {/* <a href={LevelPdf} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a> */}
        </div>
      </div>
      <div className="sensor-right">
        <table className="level-spec-table">
          <tbody>
            <tr><td>Type</td><td>Capacitance Level Switch</td></tr>
            <tr><td>Media</td><td>Liquid, Powder, Sticky</td></tr>
            <tr><td>Connection</td><td>1/2” BSP (M)</td></tr>
            <tr><td>Probe Length</td><td>11mm (customizable maximum 250 mm)</td></tr>
            <tr><td>Temperature</td><td>-40…115°C (high temperature type can reach 200°C)</td></tr>
            <tr><td>Voltage</td><td>18…30 DC</td></tr>
            <tr><td>Sensing Element</td><td>SS316L</td></tr>
            <tr><td>Output</td><td>2 switching outputs, NPN or PNP</td></tr>
            <tr><td>Factory Setting</td><td>Water-Based Media</td></tr>
            <tr><td>Protection</td><td>IP68 / IP69K</td></tr>
            <tr><td>Connection</td><td>M12 Connector</td></tr>
            <tr><td>Material</td><td>PEEK and 316L stainless steel</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* ➕ Second Product Below (Sample Product - Replace with Actual Data) */}
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={ForkLevelSwitch} alt="Radar Level Switch" />
          <h3>Tuning Fork Level Switch</h3>
          <a href={ForkLevelSwitchPdf} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a>
        </div>
      </div>
      <div className="sensor-right">
        <table className="level-spec-table">
  <tbody>
    <tr><td>Supply Voltage</td><td>20–60V DC | 20–250V DC | 50/60Hz</td></tr>
    <tr><td>Switching Time</td><td>Approximately 2 seconds when covered with medium, and approximately 3 seconds when uncovered</td></tr>
    <tr><td>Ambient Temperature</td><td>-40 to 70℃</td></tr>
    <tr><td>Storage Temperature</td><td>-40 to 85℃</td></tr>
    <tr><td>Medium Temperature</td><td>-40 to 250℃</td></tr>
    <tr><td>Operating Pressure</td><td>-1 to 40 bar</td></tr>
    <tr><td>Detectable Media</td><td>Powder and granules ≥ 10 mm, density &gt; 0.1 g/cm³; liquid, viscosity = 10,000 mm²/s, density &gt; 0.7 g/cm³</td></tr>
    <tr><td>Connection Type</td><td>G1-1/2” G1”</td></tr>
    <tr><td>Electronic Connection</td><td>M12×P1.0 Connector</td></tr>
    <tr><td>Housing Materials</td><td>ABS Aluminum Alloy</td></tr>
    <tr><td>Fork Materials</td><td>Stainless Steel S304 / Stainless Steel S316</td></tr>
    <tr><td>Output Type</td><td>Relay output, negative AC 250V/4A, DC 60V/4A; Collector open circuit (NPN) output, negative 400mA; Collector open circuit (PNP) output, negative 400mA</td></tr>
    <tr><td>Power Consumption</td><td>3W Max (DC power supply), 15W Max (AC power supply)</td></tr>
  </tbody>
</table>

      </div>
    </div>


    {/* ✅ Third Product - Point Level Switch */}
<div className="level-product-table">
  <div className="level-product-left">
    <div className="sensor-feature-card">
      <img src={pointLevelSwitch} alt="Point Level Switch" />
      <h3>Point Level Switch</h3>

      {/* Add PDF if available */}
      <a href={PointLevelSwitchPdf} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf />Download</button>
      </a>
    </div>
  </div>

  <div className="sensor-right">
    <table className="level-spec-table">
      <tbody>
        <tr><td>Measuring Hysteresis</td><td>±1mm</td></tr>
        <tr><td>Medium Characteristics</td><td>DC ≥ 1.5</td></tr>
        <tr><td>Response Time</td><td>0.2s</td></tr>
        <tr><td>Repeatability</td><td>±5mm</td></tr>

        {/* Process Conditions */}
        <tr><td>Process Temperature</td><td>-40℃ ~ +115℃</td></tr>
        <tr><td>Process Pressure</td><td>-0.1 ~ +10MPa</td></tr>

        {/* Environmental */}
        <tr><td>Protective Level</td><td>IP67</td></tr>
        <tr><td>Humidity</td><td>&lt;98% RH</td></tr>
        <tr><td>Environment Temperature</td><td>M12 Connector: -40℃ ~ 85℃</td></tr>



        {/* Power Supply */}
        <tr><td>Voltage Range</td><td>12~30VDC</td></tr>

        <tr><td>Supply Current</td><td>8mA (Std), 50mA (Max)</td></tr>





      </tbody>
    </table>
  </div>
</div>

  </>
)}


          {activeTab === 'leveltransmitter' && (
            <>

            
              <div className="level-product-table">
<div className="sensor-feature-card">
                  <img src={capacitiveLevel} alt="Capacitive Level Transmitter" />
                  <h3>Guide Radar Level Transmitter</h3>
                  <a href={CapacitiveLevelTransmitterPdf} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a>
                </div>
                <div className="sensor-right">
<table className="level-spec-table">
                    <tbody>
                      <tr><td>Application</td><td>Measurement of liquid and solid powder, complex process conditions, acids, alkalis or other corrosive media</td></tr>
                      <tr><td>Media</td><td>Corrosive Liquids, Powder, Liquid</td></tr>
                      <tr><td>Range</td><td>20m</td></tr>
                      <tr><td>Measurement precision</td><td>±10mm</td></tr>
                      <tr><td>Temperature</td><td>-40 to 250°C</td></tr>
                      <tr><td>Power</td><td>10-36 V DC</td></tr>
                      <tr><td>Output</td><td>(4~20)mA/HART/RS485</td></tr>
                      <tr><td>Connection</td><td>Thread / flange (optional)</td></tr>
                      <tr><td>Enclosure</td><td>Aluminum / plastic</td></tr>
                      <tr><td>Explosion-proof certification</td><td>Exia IICT6 Ga/Exd [ia] IICT6 Gb</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>






                <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={radarLevelMeter} alt="Radar Level Meter" />
        <h3>Radar Level Meter</h3>

        <a href={RadarLevelMeterPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="sensor-right">
      <table className="level-spec-table">
  <tbody>
    <tr><td>Measuring Range</td><td>0.08–10m, 0.08–20m (customizable range)</td></tr>
    <tr><td>Measurement Error</td><td>1mm</td></tr>
    <tr><td>Resolution</td><td>0.1mm</td></tr>
    <tr><td>Measurement Frequency</td><td>1Hz–100Hz (default: 100Hz)</td></tr>
    <tr><td>Signal Output</td><td>PNP / NPN / 4–20mA / 0–10V / RS485 (proprietary protocol)</td></tr>
    <tr><td>Power Supply</td><td>DC 24V (9V–30V)</td></tr>
    <tr><td>Ambient Operating Temperature</td><td>-20°C to +70°C</td></tr>
    <tr><td>Ambient Operating Humidity</td><td>0% to 95% RH</td></tr>
    <tr><td>Protection Rating</td><td>IP67</td></tr>
    <tr><td>Medium</td><td>The dielectric constant of the medium being measured is greater than 2</td></tr>
  </tbody>
</table>

    </div>
  </div>



  
              <div className="level-product-table">
<div className="sensor-feature-card">
                  <img src={radar27} alt="Radar Level Transmitter" />
                  <h3>Radar Level Transmitter</h3>
                  <a href={RadarLevel27Pdf} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a>
                </div>
                <div className="sensor-right">
                  <table className="level-spec-table">
                    <tbody>
                      <tr><td>Frequency</td><td>76GHz ~ 81GHz</td></tr>
                      <tr><td>Range</td><td>6m - 60m</td></tr>
                      <tr><td>Accuracy</td><td>±1mm</td></tr>
                      <tr><td>Beam Angle</td><td>3° / 8°</td></tr>
                      <tr><td>Power</td><td>15 ~ 28VDC</td></tr>
                      <tr><td>Communication</td><td>MODBUS HART</td></tr>
                      <tr><td>Output</td><td>4~20mA / RS-485</td></tr>
                      <tr><td>Enclosure</td><td>Aluminum alloy, ABS Housing</td></tr>
                      <tr><td>Protection</td><td>IP67</td></tr>
                      <tr><td>Explosion-Proof</td><td>Ex d ia ll CT6 Gb / IP67 </td></tr>
                    </tbody>
                  </table>
                </div>
              </div>



                            <div className="level-product-table">
<div className="sensor-feature-card">
                  <img src={radar28} alt="Radar Level Transmitter" />
                  <h3>Intelligent Ultrasonic Level Transmitter</h3>
                  <a href={RadarLevelTransmitterPdf} target="_blank" rel="noopener noreferrer">
                    <button className="download-catalog-btn"><FaFilePdf />Download</button>
                  </a>
                </div>
                <div className="sensor-right">
                  <table className="level-spec-table">
                    <tbody>
                      <tr><td>Frequency</td><td>20KHz ~ 2000KHz</td></tr>
                      <tr><td>Range</td><td>1m - 40m</td></tr>
                      <tr><td>Accuracy</td><td>±1mm</td></tr>
                      <tr><td>Emission Angle</td><td>10°</td></tr>
                      <tr><td>Power</td><td>15 ~ 28VDC</td></tr>
                      <tr><td>Communication</td><td>MODBUS HART</td></tr>
                      <tr><td>Output</td><td>0~20mA; 4~20mA; 0~5V; 0~10V (Selected when ordering) <br/>RS485 (Supporting Modbus)</td></tr>
                      <tr><td>Enclosure</td><td>ABS engineering plastics, nylon</td></tr>
                      <tr><td>Protection</td><td>IP65, IP67</td></tr>
                      <tr><td>Explosion-Proof</td><td>Exiall BT4Gb (Selected when ordering) </td></tr>
                    </tbody>
                  </table>
                </div>
              </div>


            </>
          )}




          {/* {activeTab === 'forklevel' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={ForkLevelSwitch} alt="Fork Level Switch" />
        <h3>Fork Level Switch</h3>

        <a href={ForkLevelSwitchPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="sensor-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Supply Voltage</td><td>20–60V DC | 20–250V DC | 50/60Hz</td></tr>
          <tr><td>Switching Time</td><td>Approx. 2 sec covered, 3 sec uncovered</td></tr>
          <tr><td>Ambient Temp.</td><td>-40 to 70℃</td></tr>
          <tr><td>Storage Temp.</td><td>-40 to 85℃</td></tr>
          <tr><td>Medium Temp.</td><td>-40 to 250℃</td></tr>
          <tr><td>Operating Pressure</td><td>-1 to 40 bar</td></tr>
          <tr><td>Detectable Media</td><td>Powder, Granules ≥10mm, Liquids (viscosity 10,000 mm²/s)</td></tr>
          <tr><td>Connection Type</td><td>G1-1/2” / G1”</td></tr>
          <tr><td>Housing Material</td><td>ABS Aluminum Alloy</td></tr>
          <tr><td>Fork Material</td><td>SS304 / SS316</td></tr>
          <tr><td>Output</td><td>Relay, NPN, PNP (400 mA)</td></tr>
          <tr><td>Power Consumption</td><td>DC: 3W max / AC: 15W max</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}



{activeTab === 'ultrasonic' && (
  <div className="level-product-table">
    <div className="level-product-left">
      <div className="sensor-feature-card">
        <img src={radar28} alt="Ultrasonic Level Gauge" />
        <h3>Ultrasonic Level Gauge</h3>

        <a href={RadarLevelTransmitterPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn"><FaFilePdf />Download</button>
        </a>
      </div>
    </div>

    <div className="sensor-right">
      <table className="level-spec-table">
        <tbody>
          <tr><td>Frequency</td><td>20KHz – 2000KHz</td></tr>
          <tr><td>Range</td><td>1m – 40m</td></tr>
          <tr><td>Accuracy</td><td>±1mm</td></tr>
          <tr><td>Beam Angle</td><td>10°</td></tr>
          <tr><td>Output</td><td>4–20mA / RS485 (MODBUS)</td></tr>
          <tr><td>Power</td><td>15–28VDC</td></tr>
          <tr><td>Enclosure</td><td>ABS engineering plastic</td></tr>
          <tr><td>Protection</td><td>IP65 / IP67</td></tr>
          <tr><td>Explosion-Proof</td><td>Ex ia II BT4 Gb</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)} */}




        </div>
      </div>
      <Footer />
    </div>
  );
}
